export default __webpack_public_path__ + "static/media/logo.c7caf9b1.png";